import { Directive, ElementRef, HostListener, Input, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[ncHorizontalScroll]'
})
export class HorizontalScrollDirective implements OnDestroy {
  private isMouseOver = false;
  private scrollBarMode: 'show' | 'hide' | 'hover' = 'show';

  @Input() set ncScrollBar(value: 'show' | 'hide' | 'hover') {
    this.scrollBarMode = value;
    this.updateScrollbarVisibility();
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.applyScrollbarStyles();
  }

  ngAfterViewInit() {
    this.updateScrollbarVisibility();
  }

  private updateScrollbarVisibility() {
    switch (this.scrollBarMode) {
      case 'show':
        this.renderer.setStyle(this.el.nativeElement, 'overflow-x', 'auto');
        break;
      case 'hide':
        this.renderer.setStyle(this.el.nativeElement, 'overflow-x', 'hidden');
        break;
      case 'hover':
        this.renderer.setStyle(this.el.nativeElement, 'overflow-x', this.isMouseOver ? 'auto' : 'hidden');
        break;
    }
  }

  private applyScrollbarStyles() {
    const styles = `
      ::-webkit-scrollbar {
        height: 8px;
      }
      ::-webkit-scrollbar-track {
        background: #f1f1f1;
      }
      ::-webkit-scrollbar-thumb {
        background: rgb(206,201,207);
        border-radius: 4px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: rgb(120,108,122);
      }
    `;
    const styleElement = this.renderer.createElement('style');
    this.renderer.appendChild(styleElement, this.renderer.createText(styles));
    this.renderer.appendChild(this.el.nativeElement, styleElement);
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.isMouseOver = true;
    if (this.scrollBarMode === 'hover') {
      this.updateScrollbarVisibility();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.isMouseOver = false;
    if (this.scrollBarMode === 'hover') {
      this.updateScrollbarVisibility();
    }
  }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    if (this.isMouseOver) {
      event.preventDefault();
      this.el.nativeElement.scrollLeft += event.deltaY;
    }
  }

  ngOnDestroy() {

  }
}